module.exports = __webpack_public_path__ + "img/FPT14.31ac270f.svg";